module.exports = __webpack_public_path__ + "static/media/15.b87ccab6.jpg";